// Module
var code = `<div class="info box" ng-transclude></div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/general-ledger/common/gl-header.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;